import { useTranslation } from 'react-i18next';
import { howItWorksSteps } from '@/mocks/homeData';

export default function HowItWorksSection() {
  const { t } = useTranslation();

  return (
    <section className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block px-4 py-1.5 text-xs font-medium text-primary-700 bg-primary-100 rounded-full">
            {t('howItWorks.tag')}
          </span>
          <h2 className="mt-4 text-2xl md:text-4xl font-bold font-heading text-foreground-950">
            {t('howItWorks.title')}
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            {t('howItWorks.subtitle')}
          </p>
        </div>

        {/* Steps Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {howItWorksSteps.map((step, index) => (
            <div
              key={step.id}
              className="group relative p-5 md:p-6 bg-background-100 rounded-lg border border-background-200/60 transition-all duration-300 hover:bg-primary-500 hover:border-primary-500 cursor-default"
            >
              <div className="absolute top-3 right-3 text-4xl md:text-5xl font-bold font-heading text-foreground-100 group-hover:text-background-50/20 transition-colors">
                {String(index + 1).padStart(2, '0')}
              </div>
              <div className="relative z-10">
                <div className="w-10 h-10 md:w-11 md:h-11 flex items-center justify-center bg-background-200 rounded-lg group-hover:bg-background-50/20 transition-colors mb-4">
                  <i className={`${step.icon} text-lg md:text-xl text-primary-600 group-hover:text-background-50 transition-colors`}></i>
                </div>
                <h3 className="text-sm md:text-base font-semibold text-foreground-950 group-hover:text-background-50 transition-colors leading-snug">
                  {step.title}
                </h3>
                <p className="mt-2 text-xs md:text-sm text-foreground-600 group-hover:text-background-50/85 transition-colors leading-relaxed">
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}